module.exports = __webpack_public_path__ + "img/img.cb211f3c.svg";